import { render, staticRenderFns } from "./IpsList.vue?vue&type=template&id=3494edce&"
import script from "./IpsList.vue?vue&type=script&lang=js&"
export * from "./IpsList.vue?vue&type=script&lang=js&"
import style0 from "./IpsList.vue?vue&type=style&index=0&id=3494edce&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports